import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { CookiesProvider } from 'react-cookie';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';
import App from './App';
import reportWebVitals from './scripts/helpers/reportWebVitals';
import './App.scss';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <CookiesProvider>
            <GoogleReCaptchaProvider reCaptchaKey="6Ld7OeosAAAAAJN3lheLcyOUH_DTQ0hxPXhLVO5u">
                <App />
            </GoogleReCaptchaProvider>
        </CookiesProvider>
    </React.StrictMode>
);

reportWebVitals();
